import { spreadSearchQuery } from "../../../assets/utils/utility";
import ApiCaller from "../../Connection/ApiCaller";
const apiEndpoint = "Config";
const onFetchListConfig = async () => {
  return await ApiCaller.get(`${apiEndpoint}`);
};

const onFetchListConfigBase = async () => {
  return await ApiCaller.get(`${apiEndpoint}/GetListConfigBase`);
};

const onFetchConfig = async (id) => {
  return await ApiCaller.get(`${apiEndpoint}/${id}`);
};

const onUpdateConfig = async (id, data) => {
  return await ApiCaller.put(`${apiEndpoint}/${id}`, data);
};

const onFetchListConfigSite = async (data) => {
  let q = spreadSearchQuery(data);
  return await ApiCaller.get(`${apiEndpoint}/GetListConfigSite?${q}`);
};

const onFetchConfigSite = async (data) => {
  let q = spreadSearchQuery(data);
  return await ApiCaller.get(`${apiEndpoint}/GetConfigInfoSite?${q}`);
};

const onUpdateConfigSite = async (id, siteCode, data) => {
  return await ApiCaller.put(`${apiEndpoint}/${id}/${siteCode}`, data);
};

export {
  onFetchListConfig,
  onFetchListConfigBase,
  onFetchConfig,
  onUpdateConfig,
  onFetchListConfigSite,
  onFetchConfigSite,
  onUpdateConfigSite,
};
